'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
const Winston = require("winston");
const winston_console_format_1 = require("winston-console-format");
exports.log = Winston.createLogger({
    level: process.env.LOG_LEVEL,
    transports: [
        new Winston.transports.Console({
            format: Winston.format.combine(Winston.format.timestamp(), Winston.format.colorize({ all: true }), Winston.format.padLevels(), winston_console_format_1.consoleFormat({
                showMeta: true,
                inspectOptions: {
                    depth: Infinity,
                    colors: true,
                    maxArrayLength: Infinity,
                    breakLength: 120,
                    compact: Infinity,
                },
            })),
        })
    ],
});
//# sourceMappingURL=index.js.map